import { makeStyles, createStyles } from '@material-ui/core/styles';
import theme from 'styles/theme';

const useStyles = makeStyles(() =>
  createStyles({
    buttonBox: {
      width: '100%',
      fontSize: 18,
      textTransform: 'none',
      borderRadius: 10,
      fontWeight: 700,
      height: 51,
      '&:disabled': {
        backgroundColor: theme.palette.primary.light,
        color: theme.palette.common.white,
      },
    },
  }),
);

export default useStyles;
